import { GetServerSidePropsContext } from 'next';

import {
  LandingPageServerSideRequest,
  resolveLandingPageLocale,
} from '@silvertours/back-runtime-landingpages';
import { LandingPageLegacy } from '@silvertours/front-pages';

export const getServerSideProps = (nextContext: GetServerSidePropsContext) => {
  nextContext.res.setHeader('Cache-Control', 'no-store');
  const locale = resolveLandingPageLocale(nextContext.query.landingPage);
  const handler = new LandingPageServerSideRequest(locale);

  return handler.getServerSideProps({ ...nextContext, preview: true });
};

export default LandingPageLegacy.DynamicLandingPage;
